<template>
<div class="marketing-upgrade">
    <div class="marketing-upgrade-content">
        <div class="marketing-title">
            营销数字化升级，从现在开始
        </div>
        <div class="marketing-button" @click="goExperience">
            立即体验
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'marketing-upgrade',
    props: {
    },
    data () {
        return {
        }
    },
    methods: {
        // 跳转立即体验
        goExperience() {
            window._hmt.push(['_trackEvent', 'button','click', '首页主体底部立即体验按钮']);
             this.$router.push({ path: '/reservation',params:{type: 1,} });
        }
    }
}
</script>
<style lang="scss" scoped>
.marketing-upgrade{
    height: 330px;
    background: url('https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/big-footer-solution.png');
    background-size: cover;
    .marketing-upgrade-content{
        margin: 0 auto;
        width: 1200px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        .marketing-title{
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333;
        }
        .marketing-button{
            display: inline-block;
            width: 132px;
            height: 48px;
            background: #3777F6;
            border-radius: 2px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 48px;
            cursor: pointer;
            // text-align: center;
            margin-top: 20px;
            &:hover{
                opacity: .8;
            }
        }
    }
}

// 移动端布局
@import "@/views/home/min-home";
</style>
  